<template>
  <div>
    <div class="row mt-3">
      <div class="col">
        <icon-view
          class="mb-3"
          gradient
          icon="fa fa-dollar-sign"
          icon-background="#FF7058"
          icon-color="#fff"
          title="Adjudicación por Cifra de Cuenta"
        />
        <div
          v-if="
            billInfo.billingPurchaseOrderNumbers.length == 0 &&
              !isApprovedStatus
          "
          class="mb-4"
        >
          <custom-result-not-found />
        </div>
        <div
          v-if="!onlyShowVoucher"
          class="row mb-3 bg-secondary-13 py-3 ml-2 rounded"
        >
          <div class="col-12">
            <div v-if="!contractInfo.isDirectPayment" class="row">
              <div class="col d-flex align-items-center">
                <span class="fa-stack fa-1x color-green font-14 mr-3">
                  <em class="fas fa-circle fa-stack-2x" />
                  <em class="fas fa-usd-square fa-stack-1x fa-inverse" />
                </span>
                <span class="color-gray-6 font-16 font-weight-normal mr-2">
                  PO ID:
                </span>
                <custom-drop-down
                  v-if="showChoosePO && !isOldBilling"
                  v-model="value.purchaseOrderId"
                  class="w-50"
                  :clearable="false"
                  fieldkey="id"
                  fieldname="name"
                  :options="purchaseOrders"
                  placeholder="Seleccione"
                  @input="onPOIDChangeHandler"
                />
                <span v-else class="color-black font-16 font-weight-normal">
                  {{
                    `${billInfo.selectedPurchaseOrderId} (${billInfo.selectedPurchaseOrderBudgetYear})`
                  }}
                </span>
              </div>
              <div class="col d-flex align-items-center">
                <span class="color-gray-6 font-16 font-weight-normal mr-2">
                  Voucher ID:
                </span>
                <span class="color-black font-16 font-weight-normal">
                  {{ billInfo.voucherNumber | empty }}
                </span>
              </div>
              <div class="col d-flex align-items-center">
                <span class="color-gray-6 font-16 font-weight-normal mr-2">
                  Estatus:
                </span>
                <span class="color-black font-16 font-weight-normal">
                  {{ billInfo.voucherStatus | empty }}
                </span>
              </div>
              <div class="col-auto d-flex align-items-end justify-content-end">
                <action-button
                  v-if="cantPrintDistributionNumber && paymentId"
                  i="fas fa-print"
                  variant="success"
                  @click="$emit('print-payment-distribution', paymentId)"
                >
                  Imprimir Distribución de Pago
                </action-button>
              </div>
              <div
                v-if="
                  showUpdateVoucherStatus &&
                    (!voucherTrackingInfo ||
                      !voucherTrackingInfo.cashClearedDate)
                "
                class="col-auto d-flex align-items-end justify-content-end"
              >
                <action-button
                  v-if="canUpdateSifde"
                  i="fas fa-redo-alt"
                  variant="outline-success"
                  @click="
                    $emit('on-update-voucher-status', billInfo.voucherNumber)
                  "
                />
              </div>
            </div>
            <div v-else class="row">
              <div class="col-3 d-flex align-items-center">
                <span class="fa-stack fa-1x color-green font-14 mr-3">
                  <em class="fas fa-circle fa-stack-2x" />
                  <em class="fas fa-usd-square fa-stack-1x fa-inverse" />
                </span>
                <span class="color-gray-6 font-16 font-weight-normal mr-2">
                  Número de Voucher:
                </span>
                <span v-show="canEditVoucherInfo">
                  <validation-observer ref="voucherNumberRef" novalidate>
                    <validation-provider v-slot="{ errors }" rules="required">
                      <custom-input
                        v-model="voucherNumber"
                        class="custom-input__extended w-100"
                        custom-error-msg="El voucher es requerido."
                        :error="errors[0]"
                      />
                    </validation-provider>
                  </validation-observer>
                </span>
                <span
                  v-if="!canEditVoucherInfo && billInfo.voucherNumber"
                  class="color-black font-16 font-weight-normal"
                >
                  {{ billInfo.voucherNumber | empty }}
                </span>
              </div>
              <div class="col d-flex justify-content-end align-items-center">
                <span class="color-gray-6 font-16 font-weight-normal mr-2">
                  Fecha de Voucher:
                </span>
                <validation-observer ref="voucherDateRef" novalidate>
                  <validation-provider v-slot="{ errors }" rules="required">
                    <custom-date-picker
                      v-show="canEditVoucherInfo"
                      :key="`voucher-date-${voucherDateKey}`"
                      v-model="voucherDate"
                      :custom-error-msg="'La fecha de voucher es requerida.'"
                      :error="errors[0]"
                    />

                    <span v-if="!canEditVoucherInfo && billInfo.voucherDate">
                      {{ billInfo.voucherDate | date }}
                    </span>
                  </validation-provider>
                </validation-observer>
              </div>
              <div class="col d-flex justify-content-end">
                <div class="d-flex align-items-center justify-content-end p-0">
                  <span class="color-gray-6 font-16 font-weight-normal mr-3">
                    Número de Pago:
                  </span>
                  <span>
                    <validation-observer ref="paymentIdFormRef" novalidate>
                      <validation-provider v-slot="{ errors }" rules="required">
                        <custom-input
                          v-show="isOldBilling"
                          v-model="paymentId"
                          class="custom-input__extended mr-2"
                          :custom-error-msg="'El número de pago es requerido.'"
                          :error="errors[0]"
                          maxlength="50"
                        />
                        <div>
                          <error
                            v-if="errors[0] && !isOldBilling"
                            style="position: relative;top: 1.3em;right: 9em;"
                            message="El número de pago es requerido."
                            variant="no-border"
                          />
                        </div>
                      </validation-provider>
                    </validation-observer>
                  </span>
                  <span
                    v-if="!isOldBilling"
                    class="color-black font-16 font-weight-normal mr-5"
                  >
                    {{ paymentId | empty }}
                  </span>
                </div>
              </div>
              <div class="col d-flex justify-content-end align-items-center">
                <span class="color-gray-6 font-16 font-weight-normal mr-2">
                  Fecha de Pago:
                </span>
                <validation-observer ref="paymentDateRef" novalidate>
                  <validation-provider v-slot="{ errors }" rules="required">
                    <custom-date-picker
                      v-show="isOldBilling"
                      v-model="billInfo.paymentDate"
                      :custom-error-msg="'La fecha de pago es requerida.'"
                      :error="errors[0]"
                    />
                    <div>
                      <error
                        v-if="errors[0] && !isOldBilling"
                        style="position: relative;top: 1.3em;right: 9em;"
                        message="La fecha de pago es requerida."
                        variant="no-border"
                      />
                    </div>
                  </validation-provider>
                </validation-observer>
                <span
                  v-if="!isOldBilling"
                  class="color-black font-16 font-weight-normal"
                >
                  {{ billInfo.paymentDate | date }}
                </span>
              </div>
              <div class="col-auto d-flex align-items-end justify-content-end">
                <action-button
                  v-if="billInfo.voucherNumber && contractInfo.isDirectPayment"
                  class="d-flex justify-content-center align-items-center ml-3"
                  i="fas fa-redo-alt"
                  variant="outline-success"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <error
                  v-if="
                    voucherTrackingInfo &&
                      voucherTrackingInfo.voucherStatusReason
                  "
                  :message="
                    '<b>Razón de Cancelación: </b>' +
                      voucherTrackingInfo.voucherStatusReason
                  "
                  style="border: none"
                  variant="custom-error-extended"
                />
              </div>
            </div>
            <hr />
            <div
              v-if="isPurchaseOrdersEmpty"
              class="col-12 bg-white rounded p-4 d-flex align-items-center justify-content-center"
            >
              <action-button
                class="border w-40 btn"
                i="fas fa-file-plus color-primary-1"
                text="Presione aquí para añadir cifra"
                @click="onAddNumberHandler"
              />
            </div>
            <div
              v-for="(digit, index) in billInfo.billingPurchaseOrderNumbers"
              :key="`payment_list_${index}`"
              class="mb-3 bg-white rounded py-3 mb-4 pl-3 mt-3"
            >
              <div class="row">
                <div class="col-md-4 mt-1">
                  <div class="color-secondary-6 font-14">
                    Número de Cifra:
                  </div>
                  <div class="color-black font-16">
                    {{ digit.fullNumber }}
                  </div>
                </div>
                <div class="col-sm mt-1">
                  <div class="color-secondary-6 font-14">
                    Número de línea:
                  </div>
                  <div class="color-black font-16">
                    {{ digit.lineNumber }}
                  </div>
                </div>
                <div class="col-sm mt-1">
                  <div class="color-secondary-6 font-14">
                    Tipo de Cifra:
                  </div>
                  <div class="color-black font-16">
                    {{ digit.digitType }}
                  </div>
                </div>
                <div class="col-sm mt-1">
                  <div class="color-secondary-6 font-14">
                    Grupo de edad:
                  </div>
                  <div class="color-black font-16">
                    {{ digit.ageRange }}
                  </div>
                </div>
                <div class="col-sm mt-3 mt-md-1 mt-sm-3">
                  <div class="color-secondary-6 font-14">
                    Monto:
                  </div>
                  <div class="color-black font-16 font-14">
                    {{ digit.amount | price }}
                  </div>
                </div>

                <div class="col-sm mt-1 mr-3 mr-md-0 mr-sm-3 text-right">
                  <action-button
                    v-if="canSaveVoucherInfo"
                    i="fas fa-save"
                    text="Guardar"
                    variant="success ml-2"
                    @click="onSaveVoucherInfo"
                  />
                </div>

                <div class="col-sm mt-1 mr-3 mr-md-0 mr-sm-3 text-right">
                  <action-button
                    v-if="isApprovedStatus && !billInfo.voucherNumber"
                    i="fas fa-times-circle"
                    variant="outline-danger btn-cancel danger m-2 pr-4 mr-md-4"
                    @click="deleteBillingDigit(digit)"
                  >
                    Eliminar
                  </action-button>
                </div>
              </div>
            </div>
            <div
              v-if="billInfo.addDigitForm && !billInfo.voucherNumber"
              class="row mt-3 bg-white rounded p-2 mx-0"
            >
              <div class="col">
                <div class="mb-2">
                  <validation-observer
                    ref="billingPaymentResultRef"
                    novalidate
                    tag="form"
                  >
                    <div class="row">
                      <div class="col-md-4">
                        <div class="color-secondary-6 font-14">
                          Número de Cifra:
                        </div>
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                        >
                          <custom-drop-down
                            v-model="value.purchaseOrderNumber"
                            class="w-100"
                            :clearable="false"
                            custom-error-msg="Favor seleccionar al menos una cifra de cuenta."
                            :error="errors[0]"
                            fieldkey="id"
                            fieldname="name"
                            :options="digitNumbers"
                            placeholder="Seleccione"
                            @input="onPurchaseOrderChange"
                          />
                        </validation-provider>
                      </div>
                      <div class="col-sm mt-1 pl-5">
                        <div class="color-secondary-6 font-14">
                          Número de línea:
                        </div>
                        <div class="color-black font-16">
                          {{ lineNumber }}
                        </div>
                      </div>
                      <div class="col-sm mt-1 pl-5">
                        <div class="color-secondary-6 font-14">
                          Tipo de Cifra:
                        </div>
                        <div class="color-black font-16">
                          {{ digitType }}
                        </div>
                      </div>
                      <div
                        v-if="!contractInfo.isDirectPayment"
                        class="col-sm mt-1 pl-5"
                      >
                        <div class="color-secondary-6 font-14">
                          Grupo de Edad:
                        </div>
                        <div class="color-black font-16">
                          {{ billingServiceCategoryName }}
                        </div>
                      </div>
                      <div
                        v-if="!contractInfo.isDirectPayment"
                        class="col-sm mt-3 mt-md-1 mt-sm-3"
                      >
                        <div class="color-secondary-6 font-14">
                          Balance:
                        </div>
                        <div class="color-secondary-6font-14">
                          {{ balance | price }}
                        </div>
                      </div>
                      <div class="col-md-2 mt-3 mr-2 mt-md-1 mt-sm-3 p-md-0">
                        <div class="color-secondary-6 font-14">
                          Monto:
                        </div>
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                        >
                          <div class="input-group mb-3">
                            <custom-input
                              v-model="value.amount"
                              class="custom-input__extended w-100"
                              custom-error-msg=""
                              :error="errors[0]"
                              mask-type="Money"
                              prepend-icon="fa fa-dollar-sign"
                              :prepend-icon-left="true"
                              prepend-icon-type="success"
                            />
                            <error
                              v-if="errors[0]"
                              message="Favor de entrar el monto. (0326)."
                              variant="no-border"
                            />
                          </div>
                        </validation-provider>
                      </div>
                      <div
                        class="col-md-12 mt-1 d-flex align-items-center justify-content-end p-md-0"
                      >
                        <action-button
                          i="fas fa-times-circle"
                          variant="outline-danger btn-cancel danger"
                          @click="cancelBillingDigit()"
                        >
                          Cancelar
                        </action-button>
                        <action-button
                          i="fas fa-save"
                          variant="success m-2 pl-4 pr-4"
                          @click="saveBillingDigit()"
                        >
                          Guardar
                        </action-button>
                      </div>
                    </div>
                  </validation-observer>
                </div>
              </div>
            </div>
            <div
              v-if="
                billInfo.billingPurchaseOrderNumbers.length > 0 &&
                  !billInfo.addDigitForm &&
                  isApprovedStatus &&
                  !billInfo.voucherNumber
              "
              class="text-right mt-2"
            >
              <action-button
                class="mr-md-4"
                i="fas fa-file-plus"
                text="Añadir Cifra"
                variant="outline-success px-3"
                @click="openNewDigitForm()"
              />
            </div>
            <div
              v-if="voucherTrackingInfo && !isApprovedStatus"
              class="mt-4 bg-gray-9 rounded p-3"
            >
              <voucher-and-payment-status-info :info="voucherTrackingInfo" />
            </div>
            <slot v-bind="{ hasPurchaseOrders }" name="documents" />
          </div>
        </div>
        <div
          v-if="onlyShowVoucher"
          class="row mb-3 bg-secondary-13 py-3 ml-2 rounded"
        >
          <div class="col-12">
            <div class="row">
              <div class="col d-flex align-items-center">
                <span class="fa-stack fa-1x color-green font-14 mr-3">
                  <em class="fas fa-circle fa-stack-2x" />
                  <em class="fas fa-usd-square fa-stack-1x fa-inverse" />
                </span>
                <span class="color-gray-6 font-16 font-weight-normal mr-2">
                  Número de Cheque:
                </span>
                <span class="color-black font-16 font-weight-normal">
                  {{ billInfo.checkNumber | empty }}
                </span>
              </div>
              <div class="col d-flex align-items-center">
                <span class="color-gray-6 font-16 font-weight-normal mr-2">
                  Voucher ID:
                </span>
                <span class="color-black font-16 font-weight-normal">
                  {{ billInfo.voucherNumber | empty }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconView from 'icon-view';
import CustomDropDown from 'custom-drop-down';
import CustomDatePicker from 'custom-date-picker';
import CustomInput from 'CustomInput';
import Error from 'custom-error';
import ActionButton from 'ActionButton';
import VoucherAndPaymentStatusInfo from './VoucherAndPaymentStatusInfo.vue';
import CustomResultNotFound from 'custom-result-not-found';
import alert from 'utils/mixins/alert.mixin';
import billingStatus from '@/utils/constants/billingStatus.js';
import voucherStatus from '@/utils/constants/voucherStatus';
import {
  getDigitNumbers,
  saveVoucherInfo as _saveVoucherInfo,
} from '@/modules/billingHistory/api';
import { getDigitNumbers as _getDirectPaymentDigitNumbers } from '@/modules/reinbursement/api.js';

export default {
  name: 'PaymentAccountNumber',
  components: {
    IconView,
    CustomDropDown,
    CustomDatePicker,
    CustomInput,
    Error,
    ActionButton,
    CustomResultNotFound,
    VoucherAndPaymentStatusInfo,
  },
  mixins: [alert],
  props: {
    value: {
      //Form
      type: Object,
      default: () => {
        return {
          //Only related to Forms
          purchaseOrderNumberId: 0,
          purchaseOrderNumber: null,
          amount: 0,
          billId: 0,
          purchaseOrderId: null,
          lineNumber: null,
        };
      },
    },
    canSaveVoucherInfo: {
      type: Boolean,
      default: false,
    },
    billInfo: {
      type: Object,
      default: () => {
        return {
          billingPurchaseOrderNumbers: [],
          purchaseOrderNumbers: [],
          totalPurchase: 0,
          BillTotal: 0,
          addDigitForm: false,
          purchaseOrderId: null,
          voucherDate: null,
          paymentDate: null,
        };
      },
    },
    billStatus: {
      type: Number,
      default: 0,
    },
    purchaseOrderPk: {
      type: Number,
      default: 0,
    },
    billTotalAmount: {
      type: Number,
      default: 0,
    },
    purchaseOrders: {
      type: Array,
      default: () => [],
    },
    voucherTrackingInfo: {
      type: Object,
      default: () => {},
    },
    showUpdateVoucherStatus: {
      type: Boolean,
      default: () => false,
    },
    contractInfo: {
      type: Object,
      default: () => {
        return {
          contractId: null,
          isDirectPayment: false,
        };
      },
    },
  },
  data: () => ({
    balance: 0,
    lineNumber: null,
    digitNumbers: null,
    billingServiceCategoryName: null,
    digitType: null,
    voucherNumber: null,
  }),

  computed: {
    billId() {
      const orders = this.billInfo?.billingPurchaseOrderNumbers ?? [];
      return orders.length > 0 ? orders[0].billId : null;
    },
    hasPurchaseOrders() {
      return Boolean(this.billInfo?.billingPurchaseOrderNumbers?.length);
    },
    canUpdateSifde() {
      return this.userHasPermissions('billing.payment.sifdeupdate');
    },
    cantPrintDistributionNumber() {
      return this.userHasPermissions(
        'provider.billing.printdistributionnumber'
      );
    },
    paymentId() {
      return this.billInfo.billingPurchaseOrderNumbers.length > 0
        ? this.billInfo.billingPurchaseOrderNumbers[0].billingPaymentId
        : null;
    },
    paymentDigitList() {
      return this.billInfo.purchaseOrderNumbers
        .filter(
          (f) =>
            !this.billInfo.billingPurchaseOrderNumbers.some(
              (s) => s.purchaseOrderNumberId == f.purchaseOrderNumberId
            )
        )
        .map(
          ({
            purchaseOrderNumberId,
            fullNumber,
            lineNumber,
            balance,
            isFederal,
          }) => ({
            id: purchaseOrderNumberId,
            name: fullNumber,
            lineNumber: lineNumber,
            balance: balance,
            isFederal,
          })
        );
    },
    canEditVoucherInfo() {
      const statuses = [
        billingStatus.EnviadoFinanzas,
        billingStatus.EnviadoFinanzasParcial,
      ];
      return (
        this.billInfo.voucherDate == null || statuses.includes(this.billStatus)
      );
    },
    isApprovedStatus() {
      return [
        billingStatus.Aprobado,
        billingStatus.EnEsperaFondos,
        billingStatus.EnEsperaAprobacionPO,
        billingStatus.EnEsperaAsistenciaTecnica,
        billingStatus.PendienteAprobacion,
      ].includes(this.billStatus);
    },
    totalPurchase() {
      let total = 0;
      if (this.billInfo.voucherStatus == voucherStatus.Cancelled) {
        return 0;
      }

      this.billInfo.billingPurchaseOrderNumbers.map((item) => {
        total += item.amount;
      });

      return total;
    },
    isPurchaseOrdersEmpty() {
      return (
        this.billInfo.billingPurchaseOrderNumbers.length == 0 &&
        !this.billInfo.addDigitForm &&
        this.isApprovedStatus
      );
    },
    showChoosePO() {
      return (
        (!this.billInfo.selectedPurchaseOrderId &&
          this.billInfo.billingPurchaseOrderNumbers.length == 0) ||
        this.isPurchaseOrdersEmpty
      );
    },
    onlyShowVoucher() {
      if (
        (this.billInfo.voucherNumber !== undefined ||
          this.billInfo.checkNumber !== undefined) &&
        this.billInfo.billingPurchaseOrderNumbers.length == 0 &&
        billingStatus.Pagado == this.billStatus
      ) {
        return true;
      }
      return false;
    },
    isOldBilling() {
      return (
        this.billStatus === billingStatus.EnviadoFinanzas &&
        (!this.billInfo.billingPurchaseOrderNumbers.length ||
          this.contractInfo.isDirectPayment)
      );
    },
    voucherDate: {
      get() {
        return this.billInfo.voucherDate;
      },
      set(value) {
        this.$set(this.billInfo, 'voucherDate', value);
      },
    },
    voucherDateKey() {
      // Generar una key única basada en la fecha para forzar re-render
      if (!this.billInfo.voucherDate) return 'empty';
      const date =
        this.billInfo.voucherDate instanceof Date
          ? this.billInfo.voucherDate
          : new Date(this.billInfo.voucherDate);
      return isNaN(date.getTime()) ? 'invalid' : date.getTime().toString();
    },
  },
  mounted() {
    this.voucherNumber = this.billInfo.voucherNumber;
  },
  watch: {
    'billInfo.voucherNumber'(newValue) {
      if (newValue) {
        this.voucherNumber = newValue;
      }
    },
    'billInfo.addDigitForm'(formState) {
      if (formState) {
        this.clearForm();
      }
    },
    'billInfo.selectedPurchaseOrderId'(formState) {
      if (formState) {
        this.clearForm();
      }
    },
  },
  created() {
    this.billInfo.totalPurchase = this.totalPurchase; //For gears
  },
  methods: {
    async onSaveVoucherInfo() {
      const isValid = await this.validateVoucherRequiredFieldsAsync();
      if (!isValid) {
        return;
      }

      const payload = {
        billId: this.billId,
        voucherNumber: this.voucherNumber ?? this.billInfo.voucherNumber,
        voucherDate: this.billInfo.voucherDate,
        paymentId: this.paymentId,
        paymentDate: this.billInfo.paymentDate,
        paymentNumber: this.billInfo.paymentId,
      };

      await _saveVoucherInfo(payload)
        .then((response) => {
          if (response.data) {
            this.ShowToast('', 'Voucher guardado exitosamente.', 'success');
            this.$emit('refresh-details');
          }
        })
        .catch(() => {
          this.ShowToast('', 'Error al guardar el voucher.', 'error');
        });
    },
    async validateVoucherRequiredFieldsAsync() {
      const referenceFields = this.$refs ?? {};

      return (
        referenceFields?.voucherNumberRef?.validate() &&
        referenceFields?.voucherDateRef?.validate() &&
        referenceFields?.paymentIdFormRef?.validate() &&
        referenceFields?.paymentDateRef?.validate()
      );
    },
    openNewDigitForm() {
      this.billInfo.addDigitForm = true;
      let poid = this.billInfo.purchaseOrderPk;
      getDigitNumbers(poid).then((data) => {
        let response = data.data.filter((t) => {
          return (
            this.billInfo.billingPurchaseOrderNumbers.filter((q) => {
              return (
                q.lineNumber == t.lineNumber &&
                t.purchaseOrderNumberId == q.purchaseOrderNumberId &&
                t.lineStatus !== 'C'
              );
            }).length == 0
          );
        });
        this.digitNumbers = response.sort((a, b) =>
          a.lineNumber > b.lineNumber ? 1 : b.lineNumber > a.lineNumber ? -1 : 0
        );
      });
    },
    async onPOIDChange() {
      let poid = this.value?.purchaseOrderId;
      let { data: response } = await getDigitNumbers(poid.id);
      if (response.length <= 0) {
        this.clearForm();
      }
      this.digitNumbers = response
        .filter((t) => t.lineStatus !== 'C')
        .sort((a, b) =>
          a.lineNumber > b.lineNumber ? 1 : b.lineNumber > a.lineNumber ? -1 : 0
        );
    },
    async onPOIDChangeHandler() {
      if (this.value.purchaseOrderNumber != null) {
        await this.ShowCancelModal(
          'Confirmación',
          'Usted cuenta con información documentada en sistema. ¿Está seguro que desea eliminar la información para cambiar el PO ID?',
          'Sí',
          'No'
        ).then(async (answer) => {
          if (!answer) return;
          this.onPOIDChange();
        });
      } else {
        this.onPOIDChange();
      }
    },
    emptyText(value) {
      return value == null || value == '' ? '-' : value;
    },
    cancelBillingDigit() {
      this.billInfo.addDigitForm = false;
    },
    async saveBillingDigit() {
      let isValid = await this.$refs.billingPaymentResultRef.validate();
      if (!isValid) {
        this.ShowToast('', 'Debe completar los campos requeridos.', 'error');
        return;
      }

      if (this.value.amount <= 0) {
        this.ShowToast('', 'El monto debe ser mayor que cero.', 'error');
        return;
      }

      //validar amount
      if (
        this.value.amount > this.balance &&
        !this.contractInfo.isDirectPayment
      ) {
        this.ShowToast(
          '',
          'El monto no puede sobrepasar el balance de la cifra seleccionada.',
          'error'
        );
        return;
      }

      if (this.value.amount > this.billTotalAmount) {
        this.ShowToast(
          '',
          'El monto no puede sobrepasar el balance total de la factura.',
          'error'
        );
        return;
      }

      if (
        this.billInfo.billingPurchaseOrderNumbers.length > 0 &&
        this.billInfo.billingPurchaseOrderNumbers.some(
          (bpo) =>
            bpo.digitType.trim().toLowerCase() !==
            this.value.purchaseOrderNumber.digitType.trim().toLowerCase()
        )
      ) {
        const type = {
          federal: 'estatal',
          estatal: 'federal',
        };
        this.ShowToast(
          '',
          `No es posible seleccionar una cifra ${this.value.purchaseOrderNumber.digitType.toLowerCase()}, ya que cuenta con una cifra ${
            type[this.value.purchaseOrderNumber.digitType.toLowerCase()]
          }.`,
          'error'
        );
        return;
      }

      this.value.lineNumber = this.lineNumber;

      this.$emit('saveBillingDigit');
      this.billInfo.totalPurchase = this.totalPurchase;
    },
    deleteBillingDigit(item) {
      this.value.purchaseOrderId = null;
      this.$emit('deleteBillingDigit', item);
    },
    onPurchaseOrderChange(value) {
      this.balance = value.doeBalanceAmount;
      this.lineNumber = value.lineNumber;
      this.digitType = value.digitType;
      this.billingServiceCategoryName = value.billingServiceCategoryName;
    },
    clearForm() {
      this.value.purchaseOrderNumber = null;
      this.value.purchaseOrderNumberId = null;
      this.balance = null;
      this.lineNumber = null;
      this.digitType = null;
      this.billingServiceCategoryName = null;
    },
    async onAddNumberHandler() {
      if (!this.contractInfo.isDirectPayment) {
        if (
          !this.value.purchaseOrderId?.id &&
          !this.billInfo.selectedPurchaseOrderId
        ) {
          this.ShowToast('', 'Debe seleccionar el PO.', 'error');
          return;
        }
        this.$emit(
          'add-purchase-order-numbers',
          this.value.purchaseOrderId?.id,
          this.value.purchaseOrderId?.year
        );
      }
      this.billInfo.addDigitForm = true;
      let { data: response } = !this.contractInfo.isDirectPayment
        ? await getDigitNumbers(this.value?.purchaseOrderId.id)
        : await _getDirectPaymentDigitNumbers(this.contractInfo.year);
      this.digitNumbers = response
        .filter((t) => t.lineStatus !== 'C')
        .sort((a, b) =>
          a.lineNumber > b.lineNumber ? 1 : b.lineNumber > a.lineNumber ? -1 : 0
        );
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
::v-deep .custom-input__extended {
  .input-group {
    .input-group-text {
      background: map-get($colors, 'green');
      color: map-get($colors, 'white');
    }
  }
}
</style>
